import { queryMicrophonePermission } from './queryMicrophonePermission.ts';

/** Who refused the microphone: the site setting in the browser, or the computer itself. */
export type MicrophoneBlock = 'browser' | 'system';

/**
 * Why the microphone was refused, or null when nothing is blocking it. A closed
 * prompt is not a block: asking again shows it again. A site permission that is
 * still granted means something below the browser said no.
 */
export async function microphoneBlockOf(error: unknown): Promise<MicrophoneBlock | null> {
  if (!(error instanceof Error) || error.name !== 'NotAllowedError') {
    return null;
  }
  if (error.message === 'Permission dismissed') {
    return null;
  }
  if (error.message === 'Permission denied by system') {
    return 'system';
  }

  const permission = await queryMicrophonePermission();
  return permission?.state === 'granted' ? 'system' : 'browser';
}
